import { render } from "./ModalADSAlertInfo.vue?vue&type=template&id=ff8658a6"
import script from "./ModalADSAlertInfo.vue?vue&type=script&lang=js"
export * from "./ModalADSAlertInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__